import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0B0D10] border-t border-white/5 py-8">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <p className="text-sm text-[#A6AFBD]/60">
              © {currentYear} Ramon Govea. All rights reserved.
            </p>
            <Link
              to="/privacypolicy"
              data-testid="footer-privacy-policy-link"
              className="text-sm text-[#A6AFBD]/60 hover:text-[#F2F4F7] transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/termsofservice"
              data-testid="footer-terms-of-service-link"
              className="text-sm text-[#A6AFBD]/60 hover:text-[#F2F4F7] transition-colors"
            >
              Terms of Service
            </Link>
          </div>

          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-sm text-[#A6AFBD]/60 hover:text-[#F2F4F7] transition-colors"
          >
            Back to top ↑
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
